<template>
  <div id="contestDetail">
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title1.png" alt="" />
      </div>
    </div>
    <div class="contestTheme">
      <!-- <p>
        2021“风潮由我”明基设计大赛，以支持中国原创设计为初心，旨在为广大设计爱好者与从业者搭建开放的创意交流平台。大赛分为自由主题单元和主题单元，自由主题单元面向全国高校学生开放，BenQ期待更多创作者不受传统思维限制，以创新、独特、意涵取胜，呈现出好故事。
      </p>
      <p>
        主题单元以“风潮由我”为主基调，为热爱中华优秀传统文化的你，提供展示平台。你心目中的国风是什么？是诗经里率真淳朴的民歌，还是雍容华贵的大唐气度？是中华上下五千年荟萃的传统元素，还是在潮流顶端盛放的本土花朵？“风潮由我”，国风本不应被定义，它的个性由你来决定！
      </p> -->
      <img src="../assets/img/detailPic/dasaizhuti.png" alt="" />
    </div>
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title2.png" alt="" />
      </div>
    </div>
    <div class="timeLine">
      <img src="../assets/img/detailPic/process.png" alt="" />
    </div>
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title3.png" alt="" />
      </div>
    </div>
    <div class="freeTheme-box">
      <img src="../assets/img/detailPic/自由主题.png" alt="" />
    </div>
    <div class="theme-box">
      <img src="../assets/img/detailPic/主题单元.png" alt="" />
    </div>
    <!-- <div class="addWard">
      <img src="../assets/img/detailPic/叠加奖项.png" alt="">
    </div> -->
    <!-- <div class="themeWork-box">
      <div class="head">自由主题单元</div>
      <div class="theme-content"></div>
      <div class="theme-bottom">指导奖</div>
    </div>
    <div class="schooRecruitment">校招免试直通车</div>
    <div class="themeWork-box freetheme">
      <div class="head">主题单元</div>
      <div class="theme-content"></div>
    </div> -->
    <div class="Superimpose">
      <img src="../assets/img/detailPic/叠加奖项.png" alt="" />
    </div>
    <div class="Superorg">
      <img src="../assets/img/detailPic/最佳组织奖.png" alt="" />
    </div>

    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title4.png" alt="" />
      </div>
    </div>

    <div class="judges-box">
      <img src="../assets/img/detailPic/Judges.png" alt="" />
    </div>
    <!-- <div class="videoCate">
      <div class="head">视频类</div>
      <div class="next-box">
        <div class="video-list">
          <div class="judges-item">
            <div class="img"></div>
            <div class="name">吕敬人</div>
            <div class="designation">
              <p>清华大学美术学院教授</p>
            </div>
          </div>
          <div class="judges-item">
            <div class="img"></div>
            <div class="name">吕敬人</div>
            <div class="designation">
              <p>清华大学美术学院教授</p>
            </div>
          </div>
          <div class="judges-item">
            <div class="img"></div>
            <div class="name">吕敬人</div>
            <div class="designation">
              <p>清华大学美术学院教授</p>
            </div>
          </div>
          <div class="judges-item">
            <div class="img"></div>
            <div class="name">吕敬人</div>
            <div class="designation">
              <p>清华大学美术学院教授</p>
            </div>
          </div>
          <div class="judges-item">
            <div class="img"></div>
            <div class="name">吕敬人</div>
            <div class="designation">
              <p>清华大学美术学院教授</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title5.png" alt="" />
      </div>
    </div>
    <div class="weibo-box">
      <img src="../assets/img/detailPic/weibo.png" alt="" />
    </div>
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title6.png" alt="" />
      </div>
    </div>
    <div class="notice">
      <img src="../assets/img/detailPic/notice.png" alt="" />
    </div>
    <!-- <div class="uploadbtn" @click="uploadFile">
      <img src="../assets/img/detailPic/upload.png" alt="" />
    </div> -->
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/detailPic/title7.png" alt="" />
      </div>
    </div>
    <div class="standard">
      <img src="../assets/img/detailPic/standard.png" alt="" />
    </div>
    <!-- <div class="standard-box">
      <div class="standard-item">
        <div class="item-title">艺术性</div>
        <p>
          八百标兵奔北坡书用心逻辑清晰内 <br />
          容丰富可逻辑清晰，内容丰富可<br />
          操作性强稍等。<br />
        </p>
      </div>
      <div class="standard-item"></div>
      <div class="standard-item"></div>
      <div class="standard-item"></div>
    </div> -->
    <div class="footer-box">
      <div class="orgLink">
        <div class="link-item" v-for="(item, index) in logoList.list" :key="index">
          <div class="link-item-name">{{ item.title }}</div>
          <div class="link">
            <a v-for="(item1, index) in item.data" :key="index" @click.stop="goLink(item1)">
              <img :src="item1.logoSrc" alt="" :style="{ height: item1.height }" />
            </a>
          </div>
        </div>
      </div>
      <div class="beian">
        <div class="beian-box">
          <div>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              <span>沪ICP备17047194号-5</span>
            </a>
          </div>
          <div class="line"></div>
          <div>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502000550" target="_blank">
              <img src="../assets/img/ga_icon.png" alt="" />
              <span>苏公网安备32050502000550号</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { reactive } from "vue";
import { brandHit } from "../utils/apis/brandApi";

export default {
  name: "contestDetail",

  setup() {
    const router = useRouter();
    function uploadFile() {
      router.push({ path: "/upLoadFile" });
      document.documentElement.scrollTop = 820;
    }

    const logoList = reactive({
      list: [
        {
          title: "主 办 方",
          data: [
            {
              name: "明基",
              logoSrc: require("../assets/img/infoPic/BenQ.png"),
              href: "https://s.tb.cn/c.0uNQBj",
              height: "23px",
            },
          ],
        },
        {
          title: "协 办 方",
          data: [
            {
              name: "CG模型网",
              logoSrc: require("../assets/img/infoPic/moxing.png"),
              href: "https://www.cgmodel.com/",
              height: "26px",
            },
            {
              name: "蓝铅笔",
              logoSrc: require("../assets/img/infoPic/lanqianbi.png"),
              href: "https://www.lanqb.com/",
              height: "27px",
            },
            {
              name: "Wuhu",
              logoSrc: require("../assets/img/infoPic/Wuhu.png"),
              href: "https://weibo.com/u/5836279440",
              height: "45px",
            },
            {
              name: "GGAC",
              logoSrc: require("../assets/img/infoPic/GGAC.png"),
              href: "https://www.ggac.com/v2/home",
              height: "33px",
            },
          ],
        },
        {
          title: "联合品牌",
          data: [
            {
              name: "Pantone",
              logoSrc: require("../assets/img/infoPic/pantone.png"),
              href: "https://pantonecn.com",
              height: "44px",
            },
            {
              name: "CBS",
              logoSrc: require("../assets/img/infoPic/colebrook.png"),
              href: "https://mall.jd.com/view_page-257315110.html",
              height: "34px",
            },
            {
              name: "赫曼米勒",
              logoSrc: require("../assets/img/infoPic/herman.png"),
              href: "https://hermanmiller.tmall.com/",
              height: "27px",
            },
            {
              name: "绘王",
              logoSrc: require("../assets/img/infoPic/huion.png"),
              href: "https://store.huion.cn/",
              height: "24px",
            },
            {
              name: "ikbc",
              logoSrc: require("../assets/img/infoPic/ikbc.png"),
              href: "http://www.ikbc.com.cn",
              height: "28px",
            },
            {
              name: "金士顿",
              logoSrc: require("../assets/img/infoPic/kingstone.png"),
              href: "https://www.kingston.com/cn",
              height: "23px",
            },
          ],
        },
        {
          title: "支持单位",
          data: [
            {
              name: "ill",
              logoSrc: require("../assets/img/infoPic/ihdt.png"),
              href: "http://c4datc.com",
              height: "40px",
            },
            {
              name: "AD518",
              logoSrc: require("../assets/img/infoPic/ad518.png"),
              href: "http://www.ad518.com",
              height: "20px",
            },
            {
              name: "CDBC",
              logoSrc: require("../assets/img/infoPic/cdbc.png"),
              href: "https://weibo.com/207979150/",
              height: "35px",
            },
            {
              name: "涂鸦王国",
              logoSrc: require("../assets/img/infoPic/tuya.png"),
              href: "https://www.gracg.com/",
              height: "25px",
            },
          ],
        },
        {
          title: "字体支持",
          data: [
            {
              name: "造字工房",
              logoSrc: require("../assets/img/infoPic/zaozi.png"),
              href: "http://makefont.com",
              height: "40px",
            },
          ],
        },
      ],
    });

    function goLink(item) {
      brandHit({ brand: item.name }).then((res) => {
        if (res.data.code === 200) {
          window.location.href = item.href;
        }
      });
    }
    return {
      uploadFile,
      goLink,
      logoList,
    };
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTHJW";
  src: url("../assets/fonts/FZLTHJW.TTF") format("truetype");
}

#contestDetail {
  padding-top: 116px;
  background-image: url("../assets/img/detailPic/bg.png");
  background-size: cover;
  background-position: center;

  .title {
    // height: 82px;
    margin-bottom: 72px;
    display: flex;
    align-items: center;

    .title-content {
      text-align: center;
      // width: 240px;
      margin: 0 auto;
      // background-color: #94282e;
      line-height: 82px;
      height: 82px;

      color: #fff;
      font-size: 36px;
      font-weight: bold;
    }
  }

  .contestTheme {
    // width: 772px;
    // margin: 0 auto;
    // padding-bottom: 30px;
    text-align: center;
    margin-bottom: 110px;
    // font-family: "FZLTHJW";
    // p {
    //   line-height: 28px;
    //   font-size: 18px;
    //   margin-top: 30px;
    //   color: #481c03;
    // }
  }

  .timeLine {
    height: 210px;
    width: 772px;
    margin: 0 auto;
    padding-bottom: 116px;
    text-align: center;
  }

  .head {
    height: 50px;
    line-height: 50px;
    background-color: lightpink;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
  }

  .freeTheme-box {
    text-align: center;
    margin-bottom: 63px;
  }

  .theme-box {
    text-align: center;
    margin-bottom: 63px;
  }

  .themeWork-box {
    width: 772px;
    margin: 0 auto;
    height: 770px;
    margin-bottom: 10px;
    box-sizing: border-box;

    .theme-content {
      height: 586px;
      background-color: #dddd;
    }

    .theme-bottom {
      height: 134px;
      background-color: pink;
      line-height: 134px;
      text-align: center;
    }
  }

  .schooRecruitment {
    height: 80px;
    line-height: 80px;
    text-align: center;
    width: 772px;
    background-color: #ddd;
    margin: 0 auto;
    margin-bottom: 72px;
  }

  .themeWork-box.freetheme {
    height: 636px;
    margin-bottom: 72px;
  }

  .Superimpose {
    text-align: center;
    margin-bottom: 72px;
  }

  .next-box {
    height: calc(100% - 50px);
    background-color: #ddd;
  }

  .Superorg {
    text-align: center;
    margin-bottom: 110px;
  }

  .description {
    height: 78px;
    line-height: 78px;
    width: 772px;
    text-align: center;
    margin: 0 auto;
    background-color: #ddd;
    margin-bottom: 116px;
  }

  .judges-box {
    text-align: center;
    // height: 592px;
    // width: 852px;
    // margin: 0 auto;
    margin-bottom: 72px;

    .judges-list {
      display: flex;
      padding: 0 120px;
      padding-top: 32px;
      height: 100%;
      box-sizing: border-box;
      flex-wrap: wrap;
      justify-content: space-between;

      .judges-item {
        height: 248px;
        width: 132px;
        margin-right: 105px;
        background-color: pink;

        .img {
          // width: 116px;
          height: 116px;
        }

        .name {
          margin-top: 20px;
          text-align: center;
          font-size: 22px;
        }

        .designation {
          p {
            line-height: 24px;
            font-size: 12px;
          }
        }
      }

      .judges-item:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }

  .videoCate {
    // height: 570px;
    width: 852px;
    margin: 0 auto;
    margin-bottom: 116px;
  }

  .video-list {
    padding: 0 120px;
    padding-top: 32px;
    height: 100%;
    box-sizing: border-box;
    flex-wrap: wrap-reverse;
    justify-content: space-around;
    padding-bottom: 10px;
    display: flex;

    .judges-item {
      height: 248px;
      width: 132px;
      margin-right: 105px;
      background-color: pink;
      margin-bottom: 10px;

      .img {
        // width: 116px;
        height: 116px;
      }

      .name {
        margin-top: 20px;
        text-align: center;
        font-size: 22px;
      }

      .designation {
        p {
          line-height: 24px;
          font-size: 12px;
        }
      }
    }

    .judges-item:nth-child(3n) {
      margin-right: 0px;
    }

    .judges-item:nth-child(5) {
      margin-right: 0px;
    }

    .judges-item:nth-child(4) {
      margin-right: 0px;
    }
  }

  .weibo-box {
    margin-bottom: 116px;
    text-align: center;
  }

  .notice {
    width: 772px;
    margin: 0 auto;
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 116px;
    // font-family: "FZLTCHJW";
    color: #53382b;
    text-align: center;
  }

  .uploadbtn {
    text-align: center;
    height: 112px;
    // background-color: #94282e;
    // line-height: 80px;
    // width: 240px;
    // margin: 0 auto;
    text-align: center;
    // color: white;
    // font-weight: bold;
    margin-bottom: 116px;
    cursor: pointer;
    margin-left: 30px;
    // img {
    //   box-shadow: 6px 6px 20px 0px rgba(0, 0, 0, 0.6);
    // }
  }

  .standard-box {
    height: 254px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0 45px;
    box-sizing: border-box;
    margin-bottom: 116px;

    .standard-item {
      width: 265px;
      height: 100%;
      background-color: #ddd;

      .item-title {
        margin-top: 55px;
        font-size: 22px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 35px;
      }

      p {
        line-height: 24px;
        text-align: center;
      }
    }
  }

  .standard {
    text-align: center;
    padding-bottom: 116px;
    margin-left: 12px;
  }

  .footer-box {
    // height: 330px;
    box-sizing: border-box;

    .orgLink {
      background-color: #272727;
      height: 378px;
      padding-top: 72px;
      padding-bottom: 72px;

      :nth-child(5) {
        .link-item-name {
          transform: translateY(6px);
        }
      }

      .link-item {
        overflow: hidden;
        width: 761px;
        margin: 0 auto;
        margin-bottom: 25px;

        .link-item-name {
          float: left;
          line-height: 45px;
          width: 85px;
          font-family: "FZLTHJW";
          font-size: 20px;
          color: #fff;
          text-align-last: justify;
          text-align: justify;
        }

        .link {
          margin-left: 132px;
          line-height: 45px;
          font-size: 0px;

          a {
            display: inline-block;
            line-height: 45px;
            margin-right: 27px;
            cursor: pointer;

            img {
              vertical-align: middle;
            }
          }
        }
      }
    }

    .beian {
      // height: 174px;
      // line-height: 174px;
      text-align: center;
      color: #7e3e34;
      padding-top: 20px;

      .beian-box {
        padding: 12px 0 13px;
        text-align: center;

        div {
          display: inline-block;
          font-size: 12px;
          color: rgb(152, 152, 152);

          a {
            text-decoration: none;
            color: rgb(152, 152, 152);
          }

          img {
            height: 12px;
            width: 12px;
            vertical-align: middle;
            // margin-top: 3px;
            margin-right: 6px;
          }
        }

        .line {
          vertical-align: middle;
          background: rgb(152, 152, 152);
          height: 12px;
          font-size: 12px;
          margin: 0 10px;
          width: 1px;
        }
      }
    }
  }
}
</style>
